import { useState, useEffect, useContext } from "react";
import AppLayout from "@amzn/awsui-components-react/polaris/app-layout";
import { Alert, Spinner } from "@amzn/awsui-components-react";
import PageHeader from "../PageHeader";
import OrderRedriveContent from "./OrderRedriveContent";
import DarkModeContext from "../../contexes/DarkModeContext";
import { StageContext } from "../../contexes/OrderIdContext";
import { Stage } from "../../lusca-search-api/generated-src";

export default function OrderRedrive() {
  const [darkMode, setDarkMode] = useState(false);
  const [stage, setStage] = useState(() => {
    const urlParams = new URLSearchParams(window.location.search);
    return (urlParams.get("stage") as Stage) || Stage.Prod;
  });

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set("stage", stage);
    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}?${urlParams.toString()}`
    );
  }, [stage]);

  return (
    <DarkModeContext.Provider value={darkMode}>
      <StageContext.Provider value={stage}>
        <PageHeader setDarkMode={setDarkMode} />
        <AppLayout
          content={<OrderRedriveContent setStage={setStage} />}
          contentType="default"
          headerSelector="#h"
          maxContentWidth={1700}
          navigationHide
          toolsHide
        />
      </StageContext.Provider>
    </DarkModeContext.Provider>
  );
}
